export enum TimeSlotStatus {
  AVAILABLE = "available",
  BOOKED = "booked",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}
